var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-dropzone',{ref:"dropzone",staticClass:"custom-dropzone",attrs:{"id":_vm.id,"options":_vm.dropzoneOptions},on:{"vdropzone-file-added":_vm.onFileAdded,"vdropzone-removed-file":_vm.onRemoved}},[_c('div',{staticClass:"dz-message text-center"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }